import React, { useRef, useState, useEffect } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import commaImg from '../../components/LandingPage/images/commaImg.png'; // Update with correct path

// Testimonial Data
const testimonials = [
    {
        id: 1,
        quote: "Lorem ipsum dolor sit amet consectetur adipiscing elit mattis sit phasellus mollis sit aliquam sit nullam.",
        name: "Brian Clark",
        title: "VP of Marketing",
        image: "https://randomuser.me/api/portraits/men/1.jpg",
    },
    {
        id: 2,
        quote: "Lorem ipsum dolor sit amet consectetur adipiscing elit mattis sit phasellus mollis sit aliquam sit nullam.",
        name: "Brian Clark",
        title: "VP of Marketing",
        image: "https://randomuser.me/api/portraits/men/2.jpg",
    },
    {
        id: 3,
        quote: "Lorem ipsum dolor sit amet consectetur adipiscing elit mattis sit phasellus mollis sit aliquam sit nullam.",
        name: "Brian Clark",
        title: "VP of Marketing",
        image: "https://randomuser.me/api/portraits/men/3.jpg",
    },
    {
        id: 4,
        quote: "Lorem ipsum dolor sit amet consectetur adipiscing elit mattis sit phasellus mollis sit aliquam sit nullam.",
        name: "Brian Clark",
        title: "VP of Marketing",
        image: "https://randomuser.me/api/portraits/men/4.jpg",
    },
    {
        id: 5,
        quote: "Lorem ipsum dolor sit amet consectetur adipiscing elit mattis sit phasellus mollis sit aliquam sit nullam.",
        name: "Brian Clark",
        title: "VP of Marketing",
        image: "https://randomuser.me/api/portraits/men/5.jpg",
    },
];

const Testimonials = () => {
    const sliderRef = useRef(null);
    const [isAtStart, setIsAtStart] = useState(true);
    const [isAtEnd, setIsAtEnd] = useState(false);

    // Scroll testimonials to the left
    const scrollLeft = () => {
        sliderRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    };

    // Scroll testimonials to the right
    const scrollRight = () => {
        sliderRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    };

    // Check if the slider is at the start or end
    const handleScroll = () => {
        const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;

        // Check if at the start
        setIsAtStart(scrollLeft === 0);

        // Check if at the end
        setIsAtEnd(scrollLeft + clientWidth >= scrollWidth);
    };

    // Set up scroll event listener
    useEffect(() => {
        const slider = sliderRef.current;
        slider.addEventListener('scroll', handleScroll);
        return () => {
            slider.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className="relative">
            {/* Title */}
            <div className="flex justify-center items-center mb-8">
                <h1 className="text-3xl md:text-5xl px-8 md:px-0 font-extrabold text-center text-[#A67FAA]" style={{ fontFamily: 'Raleway, sans-serif' }}>
                    What Our Users Have To Say
                </h1>
            </div>

            {/* Testimonials Section */}
            <div className="relative flex justify-center items-center">
                {/* Left Arrow Button */}
                {!isAtStart && (
                    <button
                        onClick={scrollLeft}
                        className="absolute left-0 bg-[#A67FAA] text-white rounded-full p-3 hover:bg-purple-700 transition"
                    >
                        <FaArrowLeft />
                    </button>
                )}

                {/* Testimonials Slider */}
                <div
                    ref={sliderRef}
                    className="flex overflow-x-scroll scroll-smooth snap-x snap-mandatory space-x-6 max-w-6xl mx-auto px-8"
                    style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }} // Hide scrollbar
                >
                    {testimonials.map((testimonial) => (
                        <div
                            key={testimonial.id}
                            className="flex-shrink-0 w-[300px] bg-opacity-50 md:w-[350px] lg:w-[350px] rounded-xl snap-center bg-white shadow-lg  p-6 text-center"
                        >
                            {/* Comma Image */}
                            <div className="mb-4">
                                <img src={commaImg} alt="Quote" className="w-[33.6px] h-[28px] mx-auto" />
                            </div>

                            <p className="text-gray-600 font-publicSans mb-6">{testimonial.quote}</p>
                            <div className="flex items-center justify-center space-x-4">
                                <img
                                    src={testimonial.image}
                                    alt={testimonial.name}
                                    className="w-12 h-12 rounded-full object-cover"
                                />
                                <div className="text-left">
                                    <p className="text-black font-publicSans font-bold">{testimonial.name}</p>
                                    <p className="text-gray-600 font-publicSans ">{testimonial.title}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Right Arrow Button */}
                {!isAtEnd && (
                    <button
                        onClick={scrollRight}
                        className="absolute right-0 bg-[#A67FAA] text-white rounded-full p-3 hover:bg-purple-700 transition"
                    >
                        <FaArrowRight />
                    </button>
                )}
            </div>
        </div>
    );
};

export default Testimonials;
